import { createStyles } from 'antd-style'

export const useStyles = createStyles(({ token, css }) => {
  return {
    container: css`
      display: flex;
      height: 100vh;
      @media (max-width: 1080px) {
        flex-direction: column;
      }
    `,
    landingHeader: css`
      display: none;

      @media (max-width: 1000px) {
        display: flex;
        justify-content: center;
        align-items: center;
        margin: 8px 0;
      }
    `,
    leftPanel: css`
      width: 20%;
      height: 100%;
      @media (max-width: 1080px) {
        display: none;
      }
    `,
    rightPanel: css`
      width: 80%;
      height: 100%;
      display: flex;
      flex-direction: column;
      border-left: 1px solid #dee1e6;
      @media (max-width: 1080px) {
        width: 100%;
        border-left: none;
      }
    `,
    card: css`
      height: 100%;
      border-radius: ${token.borderRadiusLG}px;
      overflow: auto;
    `,

    sender: css`
      width: 100%;
    `,
    resultPanel: css`
      height: 100%;
      display: flex;
      flex-direction: column;
      flex: 1;
      justify-content: space-between;
      align-items: center;
      overflow: hidden;
    `,

    messagesContainer: css`
      display: flex;
      flex-direction: column;
      gap: 12px;
      overflow-y: auto;
      scroll-behavior: smooth;
      padding: 16px 0;
      width: 100%;
    `,
    article: css`
      width: 1000px;
      margin: 0 auto;
      @media (max-width: 1100px) {
        width: 90vw;
      }
    `,
    emptyMessages: css`
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      height: 100%;
      color: ${token.colorTextSecondary};
      font-size: 14px;
    `,
    KBContainer: css`
      height: 100%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
    `,

    KBHeader: css`
      font-size: 16px;
      color: #000000;
      line-height: 24px;
      padding: 8px 0;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 8px 16px 0 16px;
      border-bottom: 1px solid #dee1e6;
    `,
    KBInfo: css`
      overflow: auto;
      display: flex;
      flex-direction: column;
      gap: 8px;
    `,
    KBStepItem: css`
      margin: 8px 6px;
      display: flex;
      border-radius: 12px;
      cursor: pointer;
      padding: 12px 6px;
      &:hover {
        background: rgba(0, 0, 0, 0.15);
      }
    `,
    KBStepItemImg: css`
      display: flex;
      align-items: center;
      justify-content: center;
      width: 64px;
      height: 64px;
      background: #f6f8fa;
      border-radius: 8px 8px 8px 8px;
      border: 1px solid #dee1e6;
    `,
    KBTitleText: css`
      display: flex;
      flex-direction: column;
      width: 80%;
      align-items: flex-start;
      margin-left: 10px;
    `,
    KBStepTitle: css`
      font-weight: 500;
      font-size: 14px;
      color: #212329;
    `,

    KBStepDesc: css`
      margin-top: 4px;
      font-size: 12px;
      color: #868a96;
    `,
    codePreview: css`
      background-color: #f5f5f5;
      padding: 14px;
      border-radius: 8px;
      font-family: 'SF Mono', 'Monaco', 'Menlo', 'Consolas', monospace;
      font-size: 13px;
      white-space: pre-wrap;
      overflow-x: auto;
      max-height: 600px;
      overflow-y: auto;
      line-height: 1.5;
      color: #333;
      border: 1px solid #e8e8e8;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
    `,
    documentationContainer: css`
      font-size: 14px;
      line-height: 1.6;
      padding: 4px 0;

      h4 {
        margin-top: 48px;
        margin-bottom: 12px;
        font-weight: 600;
        color: ${token.colorTextHeading};
      }

      h4:first-child {
        margin-top: 0;
      }

      ul {
        padding-left: 20px;
        margin: 12px 0;
      }

      li {
        margin-bottom: 8px;
      }

      code {
        background: ${token.colorFillTertiary};
        padding: 2px 4px;
        border-radius: 4px;
        font-family: 'SF Mono', 'Monaco', 'Menlo', 'Consolas', monospace;
        font-size: 0.9em;
      }
    `,
  }
})
